<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <div class="header">
          <h2 class="topTit">Olelon Préstamo (Privacy Notice)</h2>
          <h2 class="oneTit">OLELON SA DE CV</h2>
        </div>
        <div class="textCard">
          <!-- <h1>Cam kết bảo mật</h1> -->
          <!-- <div class="title-line"></div> -->
          <div
            class="textBox"
            style="white-space: pre-wrap"
            v-html="textRender(text)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import importedImg1 from "@/page/olelonsa/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      importedImg1: importedImg1,
      keywordList: [
        // {
        //   className: "title-1",
        //   content: "Política de Privacidad",
        // },
        {
          className: "title-2",
          content: "Información clave que recopilamos",
        },
        {
          className: "title-3",
          content: "Calendario:",
        },
        {
          className: "title-3",
          content: "Información de la imagen:",
        },
        {
          className: "title-3",
          content: "Información de la lista de contactos:",
        },
        {
          className: "title-3",
          content: "Información de ubicación:",
        },
        {
          className: "title-3",
          content: "Información de la cámara:",
        },
        {
          className: "title-3",
          content: "Información del dispositivo:",
        },
        {
          className: "title-3",
          content: "Lista de aplicaciones instaladas:",
        },
        {
          className: "title-3",
          content: "Lectura de SMS financieros:",
        },
        {
          className: "title-2",
          content: "Propósitos para los cuales utilizamos la información",
        },
        {
          className: "title-2",
          content: "Almacenamiento y protección de información personal.",
        },
        {
          className: "title-2",
          content: "Retención y eliminación de datos",
        },
        {
          className: "title-2",
          content: "Uso de cookies",
        },
        {
          className: "title-2",
          content: "Actualizaciones y avisos de la política de privacidad",
        },
        {
          className: "title-2",
          content: "Contáctenos",
        },
        {
          content: "https://www.olelonsa.com",
        },
        {
          content: "admin@olelonsa.com",
        },
      ],
      text: `Olelon, S.A. de C.V. (en adelante la “Empresa”) le informa el presente aviso de privacidad de conformidad con lo dispuesto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante la “Ley”).

Olelon, S.A. de C.V. (en adelante denominada la “Compañía”) es una entidad comercial debidamente constituida bajo las leyes de México, y Olelon Préstamo es un producto de Olelon, S.A. de C.V. Olelon Préstamo opera servicios de crédito en México y, para efectos de esta declaración de privacidad, su domicilio es Av de los Insurgentes Sur No. 1228 Int. 202 03200 Mexico (Tlacoquemectal,Benito Juarez ).
Información clave que recopilamos
Calendario:
Recopilamos permisos de calendario para recordarle las fechas de pago para evitar dañar su crédito por falta de pago. Cumpliremos con nuestra política de privacidad y no compartiremos los datos de su calendario con ningún tercero sin su consentimiento.

Información de la imagen:
Cuando los usuarios utilizan funciones relacionadas con la carga de imágenes (como cargar capturas de pantalla de problemas de la APLICACIÓN, etc.), solo obtendremos la información de la imagen que usted elija con su consentimiento explícito. La información recopilada será cifrada y subida a https://www.olelonsa.com para su almacenamiento y nunca será compartida con terceros.

Información de la lista de contactos:
Cuando utiliza Olelon Préstamo, recopilamos la información de la lista de contactos que envía, incluido el nombre del contacto, el número de contacto y la información de contacto. Esto nos ayuda a confirmar su identidad y evaluar el riesgo, y actuar como contacto de emergencia si es necesario. Protegeremos estrictamente su privacidad y seguridad. Esta información de contacto se utiliza únicamente para evaluación de crédito y riesgo y no se utilizará para ningún otro propósito. Se cifrará y se cargará en nuestro centro de seguridad.

Información de ubicación:
Cuando solicita un préstamo con Olelon Préstamo, podemos recopilar sus datos de ubicación. Su ubicación actual es fundamental para el funcionamiento eficiente de nuestros servicios y nos ayuda a recomendarle productos de préstamo según su ubicación. Tenga en cuenta que cuando utiliza nuestros servicios, solo obtenemos información aproximada sobre su ubicación personal. La información recopilada no se comparte con terceros.

Información de la cámara:
Para garantizar que su préstamo se realice sin problemas, es posible que le pidamos que use una cámara para tomar una foto de su rostro y la información de su credencial requerida para solicitar el préstamo. Tenga la seguridad de que sus datos y privacidad estarán estrictamente protegidos. Solo usaremos la funcionalidad de la cámara cuando sea necesario y cualquier imagen o video capturado se usará únicamente con fines de verificación y aprobación del préstamo.

 Información del dispositivo:
Cuando solicita un préstamo, obtendremos cierta información sobre el dispositivo que está utilizando, incluida la marca del dispositivo, información del hardware de visualización, versión del sistema operativo, uso y estado del emulador, etc. Esta información nos ayuda a comprender las capacidades y la compatibilidad de su dispositivo para garantizar que nuestras aplicaciones funcionen correctamente en su dispositivo y prevenir fraudes y mantener su cuenta segura.

 Lista de aplicaciones instaladas:
Cuando solicita un préstamo, para evaluar la seguridad y legalidad de las herramientas financieras que utiliza, necesitamos recopilar únicamente la lista de aplicaciones financieras instaladas en su dispositivo. Esto nos ayudará a garantizar que accede a servicios oficiales y a evaluar riesgos. La lista de aplicaciones recopiladas se utiliza únicamente para fines de auditoría de seguridad y evaluación de riesgos.

Lectura de SMS financieros:
Olelon Préstamo recopila, transmite, sincroniza y almacena información derivada de sus mensajes SMS con el fin de habilitar la función de verificación de ingresos y detección de posibles fraudes, únicamente cuando solicita un préstamo o cuando se requiere evaluar su calificación. Para realizar este análisis, primero accedemos temporalmente a todos los SMS almacenados en su dispositivo; sin embargo, solo leeremos y procesaremos los mensajes de tipo financiero, incluyendo transacciones bancarias, pagos con tarjeta, transferencias y alertas de remesas. No se accederá a mensajes personales, promocionales ni a ningún contenido no relacionado con actividades financieras. La información recopilada se utiliza exclusivamente para fines de evaluación de riesgos y auditoría de seguridad.


Propósitos para los cuales utilizamos la información
Confirmación y verificación de identidad.
Utilizamos la información que recopilamos para verificar su identidad y garantizar la seguridad de su cuenta.
Prevenir el fraude
Utilizamos esta información para detectar y prevenir posibles fraudes.
Proporcionar servicios personalizados
Al comprender sus preferencias, intereses y necesidades, podemos ofrecerle productos y servicios personalizados.
Análisis y mejora de datos.
Obtenemos información valiosa analizando el comportamiento de los usuarios para mejorar continuamente la calidad de nuestro servicio y la experiencia del usuario.
Servicios para socios
Cuando lo permita la ley, compartiremos su información con nuestros socios para que pueda obtener más oportunidades de servicios financieros.
Cumplimos estrictamente con el principio de necesidad para el uso y almacenamiento de la información, y solo procesamos y almacenamos su información cuando es necesario. Una vez que su información ya no sea necesaria, tomaremos medidas razonables para garantizar su eliminación segura.

Almacenamiento y protección de información personal.
Para proteger la seguridad de su información personal, hemos adoptado una serie de medidas de seguridad, que incluyen:
1. Cifrado de datos: utilizamos tecnología de cifrado reconocida en la industria para proteger su información personal y subirla a https://www.olelonsa.com para su protección, por lo que no necesita preocuparse por la fuga de información.
2. Estricto control de acceso a los datos: controlamos estrictamente los permisos de acceso a los datos y solo los empleados autorizados pueden acceder
3. Auditorías de acceso a datos: Realizamos auditorías de acceso a datos e implementamos sanciones apropiadas contra los empleados que usan o divulgan ilegalmente su información.

Al acceder a nuestros servicios a través de Internet, comprenda que debido a limitaciones técnicas y posibles medios maliciosos, en la industria de Internet, a pesar de nuestros mejores esfuerzos para fortalecer las medidas de seguridad, la seguridad de la información sigue siendo del 100%. Haremos todo lo posible para garantizar la seguridad de la información personal que nos proporciona.

Retención y eliminación de datos
Es posible que necesitemos cierta información para continuar brindando nuestros servicios, por lo que no podemos evitar proporcionar esta información cambiando la configuración o eliminando la aplicación. Puede solicitar la eliminación de su cuenta y sus datos en cualquier momento, o eliminar sus datos contactándonos por correo electrónico (admin@olelonsa.com).

Uso de cookies
La Compañía puede recopilar y utilizar cookies y tecnologías similares. Cuando utiliza nuestros productos y/o servicios. Incluyendo el uso de los sitios web y aplicaciones de la Compañía.

La recopilación de cookies y tecnologías similares ayuda a la Compañía a identificarlo. Comprender sus preferencias y mejorar la forma en que la Compañía le proporciona productos y/o servicios. La Compañía puede utilizar cookies para diversos fines, como habilitar funciones básicas. Ayúdenos a comprender cómo utiliza nuestro sitio web o nuestros correos electrónicos. Ayude a la empresa a brindarle una mejor experiencia a través de canales en línea o comunicándose con usted. y garantizar que los medios publicitarios en línea que se le presenten sean más relevantes e interesantes para usted.

Puede desactivar o controlar el uso de cookies ajustando la configuración de su navegador web o dispositivo de comunicación. Cambiar la configuración que ha aceptado puede impedirle utilizar todo o parte del sitio web.

Actualizaciones y avisos de la política de privacidad
Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Puede conocer la última política de privacidad a través de nuestro sitio web o aplicación. Si realizamos cambios sustanciales en nuestra Política de Privacidad, se lo notificaremos mediante la publicación de la Política de Privacidad revisada, un aviso en el Sitio o un aviso en la Aplicación. Se recomienda que consulte la Política de privacidad periódicamente para detectar cualquier cambio.

Contáctenos
Correo electrónico: admin@olelonsa.com
Dirección: Av de los Insurgentes Sur No. 1228 Int. 202 03200 Mexico (Tlacoquemectal,Benito Juarez )`,
    };
  },
  methods: {
    textRender(textContent) {
      this.keywordList.map((item) => {
        if (textContent.includes(item.content)) {
          if (item?.className) {
            textContent = textContent.replace(
              item.content,
              `<span class="${item?.className}">${item.content}</span>`
            );
          } else {
            let htmlContent = `<a class="link" href="mailto:${item.content}">${item.content}</a>`;
            if (item.content.includes("http")) {
              htmlContent = `<a class="link" href="${item.content}" target="_blank">${item.content}</a>`;
            }
            textContent = textContent.replaceAll(item.content, htmlContent);
          }
        }
      });
      return textContent;
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}
img {
  display: block;
}
.imgBox1,
.imgBox2 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1,
.img2 {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2 {
  width: 100%;
  margin: 0;
}
.img2 {
  padding: 0 220px;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}
.textBox {
  /* margin: 70px 0 150px; */
  margin: 30px 0 150px;
  width: 90%;
  font-size: 18px;
  color: #333333;
}
.textCard {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 32px;
  /* box-shadow: 0 2px 20.8px -5px rgba(0, 0, 0, 0.25); */
  margin: 10px 0 200px;
}

.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0baf60;
  margin: 0 500px;
}
.img1 {
  margin-top: 20px;
}
::v-deep(.title-1) {
  font-weight: bold;
  font-size: 38px;
  line-height: 80px;
}
::v-deep(.title-2) {
  font-weight: bold;
  font-size: 34px;
  line-height: 70px;
}
::v-deep(.title-3) {
  font-weight: bold;
  font-size: 28px;
  line-height: 50px;
}
::v-deep(.link) {
  color: #336df4;
  margin: 0 5px;
}
.header {
  margin-left: 50px;
}
.topTit,
.oneTit {
  font-size: 40px;
  line-height: 80px;
  font-weight: bold;
  color: #014e59;
}

.topTit {
  font-size: 48px;
  line-height: 100px;
}
</style>